import { DELETE_PATIENT_UPLOADED_FILES, SET_PATIENT_UPLOADED_FILES } from "./ClinicalAction";

export const SET_ANDROLOGY_DATA ='SET_ANDROLOGY_DATA';
export const RESET_ANDROLOGY_DATA ='RESET_ANDROLOGY_DATA';

export const setAndrologyData = (keyPath, value) => ({
    type: SET_ANDROLOGY_DATA,
    payload: { keyPath, value },
    });

export const resetAndrologyData = () => ({
    type: RESET_ANDROLOGY_DATA,
    });
    
export const setPatientUploadedFiles = (data) => ({
type: SET_PATIENT_UPLOADED_FILES,
payload: data,
})

export const deletePatientUploadedFiles = (data) => ({
type: DELETE_PATIENT_UPLOADED_FILES,
payload: data,
})